import { uniqueArray } from "~/utils";
import {
  GET_LAYERS,
  SET_ACTIVE_LAYER,
  SET_BASE_MAP,
  SET_CITRA,
  SET_BIDANG_LAYER,
  SET_DIRECTION_TOGGLE,
  SET_INACTIVE_LAYER,
  SET_LAYER_NOW,
  SET_MARKERS,
  SET_SIDEBAR_TOGGLE,
  SET_LEGEND_NOW,
  SET_ALL_BIDANG,
  SET_URL_FILTER,
  SET_SPESIFICT_HIERARKI,
  SET_ACTIVE_LIST,
  SET_LAYERS_FROM_MAPS,
  SET_UPDATE_LAYERS_FROM_MAPS,
  SET_HOLLOW_MAPS,
  SET_BIDANG_RESULT,
  SET_GEOJSON_EDITING_DATA,
  SET_STYLES_VALUES,
  LOADING_RENDER_MAP,
  SET_LEGENDA_ARR,
  RESET_BIDANG_HIERARKI,
  SET_SIG_TIPE_DATA,
  SET_SHOW_PETA_JALAN,
  SET_URL_FILTER_BY_FIELD,
  SET_TRIGGER_REQUEST,
} from "./constants";

const map = {
  layer: [],
  markers: [],
  legends: [],
  layersFromMaps: [],
  urlFilter: "",
  citra: true,
  tematik: false,
  location: null,
  getLayer: null,
  layerNow: null,
  hollowMaps: false,
  allBidang: false,
  layerSearch: null,
  directionToggle: false,
  geoJSONEditingData: null,
  sidebarToggle: true,
  activeList: null,
  basemap: "googlemap",
  bidangLayer: "bidanglayer",
  bidangResult: null,
  stylesValue: null,
  loadingRenderMap: false,
  isResetBidangHierarki: false,
  sigTipeData: null,
  showPetaJalan: false,
  urlFilterByField: "",
  triggerRequest: false,
};

const MapReducers = (state = map, action) => {
  switch (action.type) {
    case SET_ACTIVE_LAYER:
      return { ...state, layer: [...state.layer, action.payload] };
    case SET_INACTIVE_LAYER:
      return {
        ...state,
        layer: state.layer.filter((el) => el.id !== action.payload.id),
      };
    case SET_BASE_MAP:
      return { ...state, basemap: action.payload };
    case SET_LAYER_NOW:
      return { ...state, layerNow: action.payload };
    case SET_DIRECTION_TOGGLE:
      return { ...state, directionToggle: action.payload };
    case SET_MARKERS:
      return { ...state, markers: [...state.markers, action.payload] };
    case GET_LAYERS:
      return { ...state, getLayer: action.payload };
    case SET_CITRA:
      return { ...state, citra: action.payload };
    case SET_SIDEBAR_TOGGLE:
      return { ...state, sidebarToggle: action.payload };
    case SET_BIDANG_LAYER:
      return { ...state, bidangLayer: action.payload };
    case SET_LEGEND_NOW:
      const checkIsExistingPayload = state.legends.some(
        (legend) => legend.ket_color === action.payload.ket_color
      );

      if (checkIsExistingPayload) {
        const editExistingLegend = state.legends.map((legend) => {
          if (legend.ket_color === action.payload.ket_color) {
            return {
              ...legend,
              warna: action.payload.warna,
            };
          }

          return legend;
        });

        return {
          ...state,
          legends: uniqueArray(editExistingLegend),
        };
      } else {
        return {
          ...state,
          legends: uniqueArray([...state.legends, action.payload]),
        };
      }
    case SET_ALL_BIDANG:
      return { ...state, allBidang: action.payload };
    case SET_URL_FILTER:
      return { ...state, urlFilter: action.payload };
    case SET_SPESIFICT_HIERARKI:
      return { ...state, layerNow: action.payload };
    case SET_ACTIVE_LIST:
      return { ...state, activeList: action.payload };
    case SET_LAYERS_FROM_MAPS:
      return { ...state, layersFromMaps: action.payload };
    case SET_UPDATE_LAYERS_FROM_MAPS:
      const { currentList, layerNew } = action.payload;

      const updateLayersFromMaps = state.layersFromMaps.map((layer) =>
        layer.feature.properties.id === currentList.feature.properties.id
          ? {
              ...layer,
              feature: {
                ...layer.feature,
                properties: {
                  ...layer.feature.properties,
                  ...layerNew,
                },
              },
            }
          : layer
      );

      return { ...state, layersFromMaps: updateLayersFromMaps };
    case SET_HOLLOW_MAPS:
      return { ...state, hollowMaps: action.payload };
    case SET_BIDANG_RESULT:
      return { ...state, bidangResult: action.payload };
    case SET_GEOJSON_EDITING_DATA:
      return { ...state, geoJSONEditingData: action.payload };
    case SET_STYLES_VALUES:
      return { ...state, stylesValue: action.payload };
    case LOADING_RENDER_MAP:
      return { ...state, loadingRenderMap: action.payload };
    case SET_LEGENDA_ARR:
      const locationURL = new URLSearchParams(window.location.search).get(
        "tipe"
      );

      const filterLegendJalan = state?.legends?.filter((legend) =>
        legend.tipe.includes(state.showPetaJalan && locationURL)
      );

      return { ...state, legends: [...filterLegendJalan, ...action.payload] };
    case RESET_BIDANG_HIERARKI:
      return { ...state, isResetBidangHierarki: action.payload };
    case SET_SIG_TIPE_DATA:
      return { ...state, sigTipeData: action.payload };
    case SET_SHOW_PETA_JALAN:
      return { ...state, showPetaJalan: action.payload };
    case SET_URL_FILTER_BY_FIELD:
      return { ...state, urlFilterByField: action.payload };
    case SET_TRIGGER_REQUEST:
      return { ...state, triggerRequest: action.payload };
    default:
      return state;
  }
};

export default MapReducers;
